import { render } from "./QuestDialog18.vue?vue&type=template&id=5a3347d8"
import script from "./QuestDialog18.vue?vue&type=script&lang=js"
export * from "./QuestDialog18.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog18.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a3347d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a3347d8', __exports__)) {
    api.reload('5a3347d8', __exports__)
  }
  
  module.hot.accept("./QuestDialog18.vue?vue&type=template&id=5a3347d8", () => {
    api.rerender('5a3347d8', render)
  })

}


export default __exports__